import React from "react";
import { useLocation } from '@reach/router';
import { ProcessLink } from "../../global/helpers"

const SubMenuItem = ({data}) => {
  const location = useLocation(); 
  const link = ProcessLink(data.link);

  if(typeof data.link.story != 'undefined'){
    let classes = "menu-item component";  

    if(location.pathname === link.url){
      classes += ' current-menu-item'
    }

    return(
      <li key={'sub_item_' } className={classes}>
        <div className="page-info">
          <a href={link.url} target={link.target} rel={link.rel} title={link.title} className={link.cssClass}>
            <span className="title">{data.title}</span>
          </a>
        </div>
      </li>
    )
  }
};
 
export default SubMenuItem;